import { render, staticRenderFns } from "./RptPurchaseJournal.vue?vue&type=template&id=26f862b3&"
import script from "./RptPurchaseJournal.vue?vue&type=script&lang=ts&"
export * from "./RptPurchaseJournal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports